<div class="main-outer company-list">
    <app-header></app-header>


    <div class="municipality-accounts">
        <div class="container">
            <!-- <div class="alert" [ngClass]="messageClass ? 'success' : 'warning'" *ngIf="displayMessage">
                <p>{{message}}</p>
                <a class="close-popup" href="javascript:void(0);" (click)="closeMessagePopup()">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.3104 1.67919L1.49018 17.4995" stroke="#4E4E4E" stroke-width="2" />
                        <line x1="1.77569" y1="1.3107" x2="17.4143" y2="17.7099" stroke="#4E4E4E" stroke-width="2" />
                    </svg>
                </a>
            </div> -->



            <div class="page-wrapper" [ngClass]="filterResposniveEvent ? 'active-sidebar' : ''">
                <div class="page-filter" *ngIf="!isCustomerAdmin">
                    <div class="page-filter-inner">
                        <div class="">
                            <a class="close-popup close-popup-filter" href="javascript:void(0);"
                                (click)="filterClickEvent()">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.3104 1.67919L1.49018 17.4995" stroke="#4E4E4E" stroke-width="2" />
                                    <line x1="1.77569" y1="1.3107" x2="17.4143" y2="17.7099" stroke="#4E4E4E"
                                        stroke-width="2" />
                                </svg>
                            </a>
                            <h2>Filters</h2>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Log Type</label>
                                <p-dropdown class="select-dropdown"  [options]="logTypeOptions" 
                                optionLabel="label"
                                optionValue="value"  [(ngModel)]="logType" [showClear]="true"
                                    placeholder="Select"></p-dropdown>
                            </div>
                            <!-- <div class="select-menu filter-group">
                                <label class="filter-lbl">Date Range</label>
                                <p-dropdown class="select-dropdown" [options]="interfaceList" optionLabel="CompanyName"
                                    optionValue="label" [(ngModel)]="selectedCompany" [showClear]="true"
                                    placeholder="Select"></p-dropdown>
                            </div> -->
                            <div class="filter-group">
                                <label class="form__label">Date Range</label>
                                <p-calendar [(ngModel)]="selectedDateRange" selectionMode="range" dateFormat="yy-mm-dd" 
                                    [showIcon]="true" placeholder="Select Date Range" panelStyleClass="body-calendar" class="form__calendar">
                                </p-calendar>
                            </div>

                            <div class="form-button-group">
                                <a class="btn-primary common-btn" (click)="applyFilters()">Apply</a>
                                <a [ngClass]="showClearFilter? '': 'active'" *ngIf="displayClearButton"
                                    class="btn-secondary" (click)="resetFilter()">Clear</a>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="page-wrapper-listing" [ngClass]="!isCustomerAdmin ? '' : 'customer-admin'">
                    <div class="title-block">
                        <h1>
                            <a class="back-btns" href="javascript:void(0);" routerLink="/company">
                                <svg fill="none" height="15" viewBox="0 0 19 15" width="19"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1 6.85L6.93744 1V4.25C17.0761 4.25 18.2457 10.5407 17.9641 14C17.5383 12.2547 17.3407 9.45 6.93744 9.45V12.7L1 6.85Z"
                                        stroke="#505050" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="1.3"></path>
                                </svg> 
                            </a> Activity Log
                        </h1>
                        <div class="responsive-filter">
                            <a href="javascript:void(0);" class="mobile-block" (click)="filterClickEvent()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
                                    <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="2" d="M20 0H0l8 9.46V16l4 2V9.46z"
                                        transform="translate(1 1)" />
                                </svg>
                            </a>

                            <button class="btn-primary add-buttons" (click)="exportToCsv()" [disabled]="loading">
                                <svg class="svg-icon" fill="#ffffff" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                        viewBox="0 0 493.525 493.525" xml:space="preserve">
                                    <g id="XMLID_30_">
                                        <path id="XMLID_32_" d="M430.557,79.556H218.44c21.622,12.688,40.255,29.729,54.859,49.906h157.258
                                            c7.196,0,13.063,5.863,13.063,13.06v238.662c0,7.199-5.866,13.064-13.063,13.064H191.894c-7.198,0-13.062-5.865-13.062-13.064
                                            V222.173c-6.027-3.1-12.33-5.715-18.845-7.732c-3.818,11.764-12.105,21.787-23.508,27.781c-2.39,1.252-4.987,2.014-7.554,2.844
                                            v136.119c0,34.717,28.25,62.971,62.968,62.971h238.663c34.718,0,62.969-28.254,62.969-62.971V142.522
                                            C493.525,107.806,465.275,79.556,430.557,79.556z"/>
                                        <path id="XMLID_31_" d="M129.037,175.989c51.419,1.234,96.388,28.283,122.25,68.865c2.371,3.705,6.434,5.848,10.657,5.848
                                            c1.152,0,2.322-0.162,3.46-0.486c5.377-1.545,9.114-6.418,9.179-12.006c0-0.504,0-1.01,0-1.51
                                            c0-81.148-64.853-147.023-145.527-148.957V64.155c0-5.492-3.038-10.512-7.879-13.078c-2.16-1.139-4.533-1.707-6.889-1.707
                                            c-2.94,0-5.848,0.88-8.35,2.584L5.751,120.526C2.162,122.98,0.018,127.041,0,131.394c-0.017,4.338,2.113,8.418,5.687,10.902
                                            l100.17,69.451c2.518,1.753,5.459,2.631,8.414,2.631c2.355,0,4.696-0.553,6.857-1.676c4.855-2.549,7.909-7.6,7.909-13.092V175.989z
                                            "/>
                                    </g>
                                </svg> Export
                            </button>
                            
                            <div class="search-box search-component">
                                <input type="text" #searchBox class="search-box__input" placeholder="Search"
                                    [(ngModel)]="searchText" (input)="onSearchChange($event.target.value)" />
                                <a href="javascript:void(0);" class="search-box__btns"><svg width="15" height="15"
                                        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.41471 12.8287C7.83796 12.8284 9.22019 12.352 10.3413 11.4753L13.8662 15L15 13.8663L11.4751 10.3416C12.3523 9.22039 12.8291 7.83791 12.8294 6.41437C12.8294 2.87765 9.95162 0 6.41471 0C2.8778 0 0 2.87765 0 6.41437C0 9.95109 2.8778 12.8287 6.41471 12.8287ZM6.41471 1.60359C9.068 1.60359 11.2257 3.76123 11.2257 6.41437C11.2257 9.06751 9.068 11.2251 6.41471 11.2251C3.76143 11.2251 1.60368 9.06751 1.60368 6.41437C1.60368 3.76123 3.76143 1.60359 6.41471 1.60359Z"
                                            fill="#434343" />
                                    </svg>
                                </a>
                            </div>
                            <div class="customer-sum" *ngIf="activityLogs?.length > 0">({{activityLogs?.length}}
                                of {{totalRecords}} Activity Logs)</div>
                        </div>
                    </div>
                    <div class="document-cabinet-list customers-list company-table">

                        <div class="column-frozen-table">
                            <p-table [value]="activityLogs" class="tables-frozen" 
                            [rows]="pageSize"  
                            [virtualScroll]="true" [scrollable]="true" 
                            [lazy]="isLazyLoadingEnabled" 
                            [totalRecords]="totalRecords" (onLazyLoad)="onLazyLoad($event)"
                            scrollHeight="400px" [sortField]="sortField" [sortOrder]="sortOrder">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="LogUniqueId">Log Unique ID<span class="sorting-icon"></span></th>
                                        <th pSortableColumn="LogType">Log Type<span class="sorting-icon"></span></th>
                                        <th pSortableColumn="LogSummary">Log Summary<span class="sorting-icon"></span>
                                        </th>
                                        <th pSortableColumn="PerformedBy">Performed By<span class="sorting-icon"></span>
                                        </th>
                                        <th pSortableColumn="CreatedDate">Date & Time<span class="sorting-icon"></span>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-log>
                                    <tr>
                                        <td>{{ log?.LogUniqueId }}</td>
                                        <td>{{ log?.LogType }}</td>
                                        <td>{{ log?.LogSummary }}</td>
                                        <td>{{ log?.PerformedBy }}</td>
                                        <td>{{ log?.CreatedDate | date:'MM/dd/yyyy, h:mm a' }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="5" class="text-center">
                                            No records found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="loader-outer" *ngIf="loading">
          <div class="loader"></div>
        </div>
    </div>
</div>